'use client';

export const URGENCY_WINDOW_DAYS = 14;
const MS_PER_DAY = 86_400_000;

/**
 * Whole days until the closing instant. `closing_date` is timestamptz, so
 * plain Date arithmetic on the instant is correct (no calendar-date
 * timezone shift). Returns null when there is no closing date.
 */
export function closesInDays(closingDate: string | null): number | null {
  if (!closingDate) return null;
  const closes = new Date(closingDate).getTime();
  if (Number.isNaN(closes)) return null;
  return Math.ceil((closes - Date.now()) / MS_PER_DAY);
}
